import { render, staticRenderFns } from "./productDetailM.vue?vue&type=template&id=2b995f27&scoped=true&"
import script from "./productDetailM.vue?vue&type=script&lang=js&"
export * from "./productDetailM.vue?vue&type=script&lang=js&"
import style0 from "./productDetailM.vue?vue&type=style&index=0&id=2b995f27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b995f27",
  null
  
)

export default component.exports